// Elapsed line for the Loading state (CONTRACT "States": Loading names "the
// request in flight, elapsed after 2 s"; feature requirements 26 forbids an
// endless loading state on the auth screens). Returns null until the
// threshold, then a whole-second sentence for the HonestState `detail` slot.
import { useEffect, useState } from 'react';

export const ELAPSED_AFTER_MS = 2000;
const TICK_MS = 1000;

export function elapsedLine(elapsedMs: number, afterMs: number = ELAPSED_AFTER_MS): string | null {
  if (!Number.isFinite(elapsedMs) || elapsedMs < afterMs) return null;
  return `${Math.floor(elapsedMs / 1000)} s elapsed.`;
}

// `active` is the request's pending flag. The counter starts when it turns on
// and is dropped the moment it turns off, so a second request never inherits
// the first one's seconds. The reset runs during render (the React pattern
// for state derived from a prop), never inside the effect.
export function useElapsedLine(active: boolean, afterMs: number = ELAPSED_AFTER_MS): string | null {
  const [elapsedMs, setElapsedMs] = useState(0);
  const [wasActive, setWasActive] = useState(active);

  if (wasActive !== active) {
    setWasActive(active);
    setElapsedMs(0);
  }

  useEffect(() => {
    if (!active) return undefined;
    const startedAt = Date.now();
    const timer = setInterval(() => setElapsedMs(Date.now() - startedAt), TICK_MS);
    return () => clearInterval(timer);
  }, [active]);

  return active ? elapsedLine(elapsedMs, afterMs) : null;
}
